/* @generated */
// prettier-ignore
if (Intl.NumberFormat && typeof Intl.NumberFormat.__addLocaleData === 'function') {
  Intl.NumberFormat.__addLocaleData({
    "data": {
      "currencies": {
        "AED": {
          "displayName": {
            "other": "အာရပ်စော်ဘွားများ ပြည်ထောင်စု ဒါဟမ်း"
          },
          "narrow": "AED",
          "symbol": "AED"
        },
        "AFN": {
          "displayName": {
            "other": "အာဖဂန် အာဖဂါနီ"
          },
          "narrow": "؋",
          "symbol": "AFN"
        },
        "ALL": {
          "displayName": {
            "other": "အယ်ဘေးနီးယား လီခ်"
          },
          "narrow": "ALL",
          "symbol": "ALL"
        },
        "AMD": {
          "displayName": {
            "other": "အာမေးနီးယား ဒရမ်"
          },
          "narrow": "֏",
          "symbol": "AMD"
        },
        "ANG": {
          "displayName": {
            "other": "နယ်သာလန် အန်တီလန် ဂင်းဒါး"
          },
          "narrow": "NAf",
          "symbol": "NAf"
        },
        "AOA": {
          "displayName": {
            "other": "အန်ဂိုလာ ကွမ်ဇာ"
          },
          "narrow": "Kz",
          "symbol": "AOA"
        },
        "ARP": {
          "displayName": {
            "other": "အာဂျင်တီးနား ပီဆို (၁၉၈၃–၁၉၈၅)"
          },
          "narrow": "ARP",
          "symbol": "ARP"
        },
        "ARS": {
          "displayName": {
            "other": "အာဂျင်တီးနား ပီဆို"
          },
          "narrow": "$",
          "symbol": "ARS"
        },
        "AUD": {
          "displayName": {
            "other": "ဩစတြေးလျ ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "A$"
        },
        "AWG": {
          "displayName": {
            "other": "အရူးဗာ ဖလိုရင်း"
          },
          "narrow": "Afl",
          "symbol": "Afl"
        },
        "AZN": {
          "displayName": {
            "other": "အဇာဘိုင်ဂျန် မာနတ်"
          },
          "narrow": "₼",
          "symbol": "AZN"
        },
        "BAM": {
          "displayName": {
            "other": "ဘော့စနီးယားနှင့် ဟာဇီဂိုဘီးနားမတ်က်"
          },
          "narrow": "KM",
          "symbol": "BAM"
        },
        "BBD": {
          "displayName": {
            "other": "ဘာဘေးဒိုးစ် ဒေါ်လာ"
          },
          "narrow": "Bds$",
          "symbol": "BBD"
        },
        "BDT": {
          "displayName": {
            "other": "ဘင်္ဂလားဒေ့ရှ် တာကာ"
          },
          "narrow": "৳",
          "symbol": "BDT"
        },
        "BEF": {
          "displayName": {
            "other": "ဘယ်လ်ဂျီယမ် ဖရန့်"
          },
          "narrow": "BEF",
          "symbol": "BEF"
        },
        "BGN": {
          "displayName": {
            "other": "ဘူလ်ဂေးရီးယား လက်ဖ်"
          },
          "narrow": "BGN",
          "symbol": "BGN"
        },
        "BHD": {
          "displayName": {
            "other": "ဘာရိန်း ဒီနား"
          },
          "narrow": "BHD",
          "symbol": "BHD"
        },
        "BIF": {
          "displayName": {
            "other": "ဘူရွန်ဒီ ဖရန့်"
          },
          "narrow": "BIF",
          "symbol": "BIF"
        },
        "BMD": {
          "displayName": {
            "other": "ဘာမြူဒါ ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "BMD"
        },
        "BND": {
          "displayName": {
            "other": "ဘရူနိုင်း ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "BND"
        },
        "BOB": {
          "displayName": {
            "other": "ဘိုလီးဗီးယား ဘိုလီးဗီယားနို"
          },
          "narrow": "Bs",
          "symbol": "BOB"
        },
        "BOP": {
          "displayName": {
            "other": "ဘိုလီးဘီးယား ပီဆို"
          },
          "narrow": "BOP",
          "symbol": "BOP"
        },
        "BRL": {
          "displayName": {
            "other": "ဘရာဇီး ရီးယဲ"
          },
          "narrow": "R$",
          "symbol": "R$"
        },
        "BSD": {
          "displayName": {
            "other": "ဘဟားမား ဒေါ်လာ"
          },
          "narrow": "B$",
          "symbol": "BSD"
        },
        "BTN": {
          "displayName": {
            "other": "ဘူတန် အံဂါလ်ထရန်"
          },
          "narrow": "BTN",
          "symbol": "BTN"
        },
        "BUK": {
          "displayName": {
            "other": "ဗမာ ကျပ်"
          },
          "narrow": "BUK",
          "symbol": "BUK"
        },
        "BWP": {
          "displayName": {
            "other": "ဘော့ဆွာနာ ပုလ"
          },
          "narrow": "P",
          "symbol": "BWP"
        },
        "BYB": {
          "displayName": {
            "other": "ဘီလာရုစ် ရူဘယ်အသစ် (၁၉၉၄–၁၉၉၉)"
          },
          "narrow": "BYB",
          "symbol": "BYB"
        },
        "BYN": {
          "displayName": {
            "other": "ဘီလာရုစ် ရူဘယ်"
          },
          "narrow": "р.",
          "symbol": "BYN"
        },
        "BYR": {
          "displayName": {
            "other": "ဘီလာရုဇ် ရူဘယ် (၂၀၀၀–၂၀၁၆)"
          },
          "narrow": "BYR",
          "symbol": "BYR"
        },
        "BZD": {
          "displayName": {
            "other": "ဘလိဇ် ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "BZD"
        },
        "CAD": {
          "displayName": {
            "other": "ကနေဒါ ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "CA$"
        },
        "CDF": {
          "displayName": {
            "other": "ကွန်ဂို ဖရန့်"
          },
          "narrow": "CDF",
          "symbol": "CDF"
        },
        "CHF": {
          "displayName": {
            "other": "ဆွစ် ဖရန့်"
          },
          "narrow": "CHF",
          "symbol": "CHF"
        },
        "CLP": {
          "displayName": {
            "other": "ချီလီ ပီဆို"
          },
          "narrow": "$",
          "symbol": "CLP"
        },
        "CNH": {
          "displayName": {
            "other": "တရုတ် ယွမ် (ဟောင်ကောင်)"
          },
          "narrow": "CNH",
          "symbol": "CNH"
        },
        "CNY": {
          "displayName": {
            "other": "တရုတ် ယွမ်"
          },
          "narrow": "¥",
          "symbol": "CN¥"
        },
        "COP": {
          "displayName": {
            "other": "ကိုလံဘီယာ ပီဆို"
          },
          "narrow": "$",
          "symbol": "COP"
        },
        "CRC": {
          "displayName": {
            "other": "ကို့စတာရီကာ ကိုလွန်"
          },
          "narrow": "₡",
          "symbol": "CRC"
        },
        "CUC": {
          "displayName": {
            "other": "နိုင်ငံခြားငွေလဲလှယ်နိုင်သော ကျူးဘားပီဆို"
          },
          "narrow": "$",
          "symbol": "CUC"
        },
        "CUP": {
          "displayName": {
            "other": "ကျူးဘား ပီဆို"
          },
          "narrow": "$",
          "symbol": "CUP"
        },
        "CVE": {
          "displayName": {
            "other": "ကိတ်ပ်ဗာဒီ အက်စ်ခူဒို"
          },
          "narrow": "CVE",
          "symbol": "CVE"
        },
        "CYP": {
          "displayName": {
            "other": "ဆိုက်ပရက်စ် ပေါင်"
          },
          "narrow": "CYP",
          "symbol": "CYP"
        },
        "CZK": {
          "displayName": {
            "other": "ချက် ခိုရိုနာ"
          },
          "narrow": "Kč",
          "symbol": "CZK"
        },
        "DEM": {
          "displayName": {
            "other": "ဂျာမဏီ မတ်"
          },
          "narrow": "DEM",
          "symbol": "DEM"
        },
        "DJF": {
          "displayName": {
            "other": "ဂျီဘူတီ ဖရန့်"
          },
          "narrow": "DJF",
          "symbol": "DJF"
        },
        "DKK": {
          "displayName": {
            "other": "ဒိန်းမတ် ခရိုဏာ"
          },
          "narrow": "kr",
          "symbol": "DKK"
        },
        "DOP": {
          "displayName": {
            "other": "ဒိုမီနီကန် ပီဆို"
          },
          "narrow": "$",
          "symbol": "DOP"
        },
        "DZD": {
          "displayName": {
            "other": "အယ်လ်ဂျီးရီးယား ဒီနာ"
          },
          "narrow": "DZD",
          "symbol": "DZD"
        },
        "EGP": {
          "displayName": {
            "other": "အီဂျစ် ပေါင်"
          },
          "narrow": "E£",
          "symbol": "EGP"
        },
        "ERN": {
          "displayName": {
            "other": "အီရီထရီးယား နာ့ခ်ဖာ"
          },
          "narrow": "ERN",
          "symbol": "ERN"
        },
        "ESP": {
          "displayName": {
            "other": "စပိန် ပယ်စေးတာ"
          },
          "narrow": "₧",
          "symbol": "ESP"
        },
        "ETB": {
          "displayName": {
            "other": "အီသီယိုးပီးယား ဘီးယာ"
          },
          "narrow": "ETB",
          "symbol": "ETB"
        },
        "EUR": {
          "displayName": {
            "other": "ယူရို"
          },
          "narrow": "€",
          "symbol": "€"
        },
        "FJD": {
          "displayName": {
            "other": "ဖီဂျီ ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "FJD"
        },
        "FKP": {
          "displayName": {
            "other": "ဖော့ကလန်ကျွန်းစု ပေါင်"
          },
          "narrow": "£",
          "symbol": "FKP"
        },
        "FRF": {
          "displayName": {
            "other": "ပြင်သစ် ဖရန့်"
          },
          "narrow": "FRF",
          "symbol": "FRF"
        },
        "GBP": {
          "displayName": {
            "other": "ဗြိတိသျှ ပေါင်"
          },
          "narrow": "£",
          "symbol": "£"
        },
        "GEL": {
          "displayName": {
            "other": "ဂျော်ဂျီယာ လားရီ"
          },
          "narrow": "₾",
          "symbol": "GEL"
        },
        "GHS": {
          "displayName": {
            "other": "ဂါနာ ဆဲဒီ"
          },
          "narrow": "GH₵",
          "symbol": "GHS"
        },
        "GIP": {
          "displayName": {
            "other": "ဂျီဘရော်လ်တာ ပေါင်"
          },
          "narrow": "£",
          "symbol": "GIP"
        },
        "GMD": {
          "displayName": {
            "other": "ဂမ်ဘီယာ ဒါလာစီ"
          },
          "narrow": "GMD",
          "symbol": "GMD"
        },
        "GNF": {
          "displayName": {
            "other": "ဂီနီရာ ဖရန့်"
          },
          "narrow": "FG",
          "symbol": "GNF"
        },
        "GTQ": {
          "displayName": {
            "other": "ဂွါတီမာလာ ခက်ဇော်လ်"
          },
          "narrow": "Q",
          "symbol": "GTQ"
        },
        "GYD": {
          "displayName": {
            "other": "ဂိုင်ယာနာ ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "GYD"
        },
        "HKD": {
          "displayName": {
            "other": "ဟောင်ကောင် ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "HK$"
        },
        "HNL": {
          "displayName": {
            "other": "ဟွန်ဒူးရပ်စ် လမ်းပီရာ"
          },
          "narrow": "L",
          "symbol": "HNL"
        },
        "HRK": {
          "displayName": {
            "other": "ခရိုအေးရှား ခူးနာ"
          },
          "narrow": "kn",
          "symbol": "HRK"
        },
        "HTG": {
          "displayName": {
            "other": "ဟေတီဂူးအော်ဒ်"
          },
          "narrow": "G",
          "symbol": "G"
        },
        "HUF": {
          "displayName": {
            "other": "ဟန်ဂေရီယံ ဖော်ရင့်တ်"
          },
          "narrow": "Ft",
          "symbol": "HUF"
        },
        "IDR": {
          "displayName": {
            "other": "အင်ဒိုနီးရှား ရူပီးယား"
          },
          "narrow": "Rp",
          "symbol": "IDR"
        },
        "ILP": {
          "displayName": {
            "other": "အစ္စရေး ပေါင်"
          },
          "narrow": "ILP",
          "symbol": "ILP"
        },
        "ILS": {
          "displayName": {
            "other": "အစ္စရေး ရှဲကလ်အသစ်"
          },
          "narrow": "₪",
          "symbol": "₪"
        },
        "INR": {
          "displayName": {
            "other": "အိန္ဒိယ ရူပီး"
          },
          "narrow": "₹",
          "symbol": "₹"
        },
        "IQD": {
          "displayName": {
            "other": "အီရတ် ဒီနာ"
          },
          "narrow": "IQD",
          "symbol": "IQD"
        },
        "IRR": {
          "displayName": {
            "other": "အီရန် ရီအော်လ်"
          },
          "narrow": "IRR",
          "symbol": "IRR"
        },
        "ISK": {
          "displayName": {
            "other": "အိုက်စလန် ခရိုဏာ"
          },
          "narrow": "kr",
          "symbol": "ISK"
        },
        "JMD": {
          "displayName": {
            "other": "ဂျမေကာ ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "JMD"
        },
        "JOD": {
          "displayName": {
            "other": "ဂျော်ဒန် ဒီနာ"
          },
          "narrow": "JOD",
          "symbol": "JOD"
        },
        "JPY": {
          "displayName": {
            "other": "ဂျပန် ယန်း"
          },
          "narrow": "¥",
          "symbol": "JP¥"
        },
        "KES": {
          "displayName": {
            "other": "ကင်ညာ သျှီလင်"
          },
          "narrow": "KES",
          "symbol": "KES"
        },
        "KGS": {
          "displayName": {
            "other": "ကာဂျစ္စတန် ဆော်မ်"
          },
          "narrow": "KGS",
          "symbol": "KGS"
        },
        "KHR": {
          "displayName": {
            "other": "ကမ္ဘောဒီးယား ရီးယဲ"
          },
          "narrow": "៛",
          "symbol": "KHR"
        },
        "KMF": {
          "displayName": {
            "other": "ကိုမိုရိုစ် ဖရန့်"
          },
          "narrow": "CF",
          "symbol": "KMF"
        },
        "KPW": {
          "displayName": {
            "other": "မြောက်ကိုရီးယား ဝမ်"
          },
          "narrow": "₩",
          "symbol": "KPW"
        },
        "KRW": {
          "displayName": {
            "other": "တောင်ကိုရီးယား ဝမ်"
          },
          "narrow": "₩",
          "symbol": "₩"
        },
        "KWD": {
          "displayName": {
            "other": "ကူဝိတ် ဒီနာ"
          },
          "narrow": "KWD",
          "symbol": "KWD"
        },
        "KYD": {
          "displayName": {
            "other": "ကေမန် ကျွန်းစု ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "KYD"
        },
        "KZT": {
          "displayName": {
            "other": "ကာဇက်စတန် ထိန်ဂျီ"
          },
          "narrow": "₸",
          "symbol": "KZT"
        },
        "LAK": {
          "displayName": {
            "other": "လာအို ကစ်"
          },
          "narrow": "₭",
          "symbol": "LAK"
        },
        "LBP": {
          "displayName": {
            "other": "လက်ဘနွန် ပေါင်"
          },
          "narrow": "L£",
          "symbol": "LBP"
        },
        "LKR": {
          "displayName": {
            "other": "သီရိလင်္ကာ ရူပီး"
          },
          "narrow": "Rs",
          "symbol": "LKR"
        },
        "LRD": {
          "displayName": {
            "other": "လိုက်ဘေးရီးယား ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "LRD"
        },
        "LSL": {
          "displayName": {
            "other": "လီဆိုသို လိုတီစ်"
          },
          "narrow": "LSL",
          "symbol": "LSL"
        },
        "LTL": {
          "displayName": {
            "other": "လစ်သူယေးနီးယားလီတားစ်"
          },
          "narrow": "Lt",
          "symbol": "LTL"
        },
        "LVL": {
          "displayName": {
            "other": "လတ်ဗီးယားလတ်"
          },
          "narrow": "Ls",
          "symbol": "LVL"
        },
        "LYD": {
          "displayName": {
            "other": "လစ်ဗျား ဒိုင်နာ"
          },
          "narrow": "LYD",
          "symbol": "LYD"
        },
        "MAD": {
          "displayName": {
            "other": "မိုရိုကို ဒရမ်"
          },
          "narrow": "MAD",
          "symbol": "MAD"
        },
        "MDL": {
          "displayName": {
            "other": "မောလ်ဒိုဗာ လယ်အို"
          },
          "narrow": "MDL",
          "symbol": "MDL"
        },
        "MGA": {
          "displayName": {
            "other": "မာလာဂါစီ အရီရရီ"
          },
          "narrow": "Ar",
          "symbol": "MGA"
        },
        "MKD": {
          "displayName": {
            "other": "မက်ဆီဒိုးနီးယား ဒီနာ"
          },
          "narrow": "MKD",
          "symbol": "MKD"
        },
        "MMK": {
          "displayName": {
            "other": "မြန်မာ ကျပ်"
          },
          "narrow": "K",
          "symbol": "K"
        },
        "MNT": {
          "displayName": {
            "other": "မွန်ဂိုးလီးယား ထူးဂရခ်"
          },
          "narrow": "₮",
          "symbol": "MNT"
        },
        "MOP": {
          "displayName": {
            "other": "မကာအို ပါတားကား"
          },
          "narrow": "MOP",
          "symbol": "MOP"
        },
        "MRO": {
          "displayName": {
            "other": "မော်ရီတေးနီးယား အူဂီးယာ (၁၉၇၃–၂၀၁၇)"
          },
          "narrow": "MRO",
          "symbol": "MRO"
        },
        "MRU": {
          "displayName": {
            "other": "မော်ရီတေးနီးယန်း အူဂီးယာ"
          },
          "narrow": "MRU",
          "symbol": "MRU"
        },
        "MUR": {
          "displayName": {
            "other": "မောရစ်ရှ ရူပီး"
          },
          "narrow": "Rs",
          "symbol": "MUR"
        },
        "MVR": {
          "displayName": {
            "other": "မော်လ်ဒိုက် ရူးဖီရာ"
          },
          "narrow": "MVR",
          "symbol": "MVR"
        },
        "MWK": {
          "displayName": {
            "other": "မာလာဝီ ခွါးချာ"
          },
          "narrow": "MWK",
          "symbol": "MWK"
        },
        "MXN": {
          "displayName": {
            "other": "မက်ကဆီကို ပီဆို"
          },
          "narrow": "$",
          "symbol": "MX$"
        },
        "MYR": {
          "displayName": {
            "other": "မလေးရှား ရင်းဂစ်"
          },
          "narrow": "RM",
          "symbol": "MYR"
        },
        "MZN": {
          "displayName": {
            "other": "မိုဇမ်ဘစ် မက်တီခယ်လ်"
          },
          "narrow": "MZN",
          "symbol": "MZN"
        },
        "NAD": {
          "displayName": {
            "other": "နမီးဘီးယား ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "NAD"
        },
        "NGN": {
          "displayName": {
            "other": "နိုင်ဂျီးရီးယား နိုင်းရာ"
          },
          "narrow": "₦",
          "symbol": "NGN"
        },
        "NIO": {
          "displayName": {
            "other": "နီကာရာဂွါ ခိုးဒိုဘာ"
          },
          "narrow": "C$",
          "symbol": "NIO"
        },
        "NOK": {
          "displayName": {
            "other": "နော်ဝေ ခရိုဏာ"
          },
          "narrow": "kr",
          "symbol": "NOK"
        },
        "NPR": {
          "displayName": {
            "other": "နီပေါ ရူပီး"
          },
          "narrow": "Rs",
          "symbol": "NPR"
        },
        "NZD": {
          "displayName": {
            "other": "နယူးဇီလန် ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "NZ$"
        },
        "OMR": {
          "displayName": {
            "other": "အိုမန်နီ ရီရယ်"
          },
          "narrow": "OMR",
          "symbol": "OMR"
        },
        "PAB": {
          "displayName": {
            "other": "ပနားမား ဘလျဘိုးအာ"
          },
          "narrow": "B/.",
          "symbol": "B/."
        },
        "PEN": {
          "displayName": {
            "other": "ပီရူး ဆိုးလ်"
          },
          "narrow": "PEN",
          "symbol": "PEN"
        },
        "PGK": {
          "displayName": {
            "other": "ပါပူအာ နယူးဂီနီ ခီးနာ"
          },
          "narrow": "PGK",
          "symbol": "PGK"
        },
        "PHP": {
          "displayName": {
            "other": "ဖိလစ်ပိုင် ပီဆို"
          },
          "narrow": "₱",
          "symbol": "PHP"
        },
        "PKR": {
          "displayName": {
            "other": "ပါကစ္စတန် ရူပီး"
          },
          "narrow": "Rs",
          "symbol": "PKR"
        },
        "PLN": {
          "displayName": {
            "other": "ပိုလန် ဇလော့တီ"
          },
          "narrow": "zł",
          "symbol": "PLN"
        },
        "PYG": {
          "displayName": {
            "other": "ပါရာဂွေး ဂွါးအ်နီး"
          },
          "narrow": "₲",
          "symbol": "PYG"
        },
        "QAR": {
          "displayName": {
            "other": "ကာတာရီ ရီရယ်"
          },
          "narrow": "QAR",
          "symbol": "QAR"
        },
        "RON": {
          "displayName": {
            "other": "ရိုမေးနီးယား လယ်အို"
          },
          "narrow": "lei",
          "symbol": "RON"
        },
        "RSD": {
          "displayName": {
            "other": "ဆားဘီးယား ဒယ်နား"
          },
          "narrow": "RSD",
          "symbol": "RSD"
        },
        "RUB": {
          "displayName": {
            "other": "ရုရှ ရူဘယ်"
          },
          "narrow": "₽",
          "symbol": "RUB"
        },
        "RUR": {
          "displayName": {
            "other": "ရုရှ ရူဘယ် (၁၉၉၁–၁၉၉၈)"
          },
          "narrow": "RUR",
          "symbol": "RUR"
        },
        "RWF": {
          "displayName": {
            "other": "ရဝန်ဒါ ဖရန့်"
          },
          "narrow": "RF",
          "symbol": "RWF"
        },
        "SAR": {
          "displayName": {
            "other": "ဆော်ဒီအာရေးဗီးယား ရီယော်လ်"
          },
          "narrow": "SAR",
          "symbol": "SAR"
        },
        "SBD": {
          "displayName": {
            "other": "ဆော်လမွန်ကျွန်းစု ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "SBD"
        },
        "SCR": {
          "displayName": {
            "other": "ဆေးရှဲ ရူပီး"
          },
          "narrow": "SCR",
          "symbol": "SCR"
        },
        "SDG": {
          "displayName": {
            "other": "ဆူဒန် ပေါင်"
          },
          "narrow": "SDG",
          "symbol": "SDG"
        },
        "SDP": {
          "displayName": {
            "other": "ဆူဒန် ပေါင်အဟောင်း"
          },
          "narrow": "SDP",
          "symbol": "SDP"
        },
        "SEK": {
          "displayName": {
            "other": "ဆွီဒင် ခရိုဏာ"
          },
          "narrow": "kr",
          "symbol": "SEK"
        },
        "SGD": {
          "displayName": {
            "other": "စင်္ကာပူ ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "SGD"
        },
        "SHP": {
          "displayName": {
            "other": "စိန့်ဟယ်လယ်နာ ပေါင်"
          },
          "narrow": "£",
          "symbol": "SHP"
        },
        "SLL": {
          "displayName": {
            "other": "ဆီယာရာလီယွန်း လီအိုနီ"
          },
          "narrow": "SLL",
          "symbol": "SLL"
        },
        "SOS": {
          "displayName": {
            "other": "ဆိုမာလီ သျှီလင်"
          },
          "narrow": "SOS",
          "symbol": "SOS"
        },
        "SRD": {
          "displayName": {
            "other": "ဆူရီနမ်း ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "SRD"
        },
        "SSP": {
          "displayName": {
            "other": "တောင်ဆူဒန် ပေါင်"
          },
          "narrow": "£",
          "symbol": "SSP"
        },
        "STD": {
          "displayName": {
            "other": "ဆောင်တူမေးနှင့် ပရင်စီပီ ဒိုဘရာ"
          },
          "narrow": "STD",
          "symbol": "STD"
        },
        "STN": {
          "displayName": {
            "other": "ဆောင်တူမေးနှင့် ပရင်စီပီ ဒိုဘရာစ် (၂၀၁၈)"
          },
          "narrow": "Db",
          "symbol": "STN"
        },
        "SUR": {
          "displayName": {
            "other": "ဆိုဗီယက် ရူဗယ်"
          },
          "narrow": "SUR",
          "symbol": "SUR"
        },
        "SYP": {
          "displayName": {
            "other": "ဆီးရီးယား ပေါင်"
          },
          "narrow": "£",
          "symbol": "SYP"
        },
        "SZL": {
          "displayName": {
            "other": "ဆွာဇီလန် လီလန်းဂီနီ"
          },
          "narrow": "SZL",
          "symbol": "SZL"
        },
        "THB": {
          "displayName": {
            "other": "ထိုင်း ဘတ်"
          },
          "narrow": "฿",
          "symbol": "฿"
        },
        "TJS": {
          "displayName": {
            "other": "တာဂျစ်ကစ္စတန် ဆိုမိုနီ"
          },
          "narrow": "TJS",
          "symbol": "TJS"
        },
        "TMT": {
          "displayName": {
            "other": "တာ့ခ်မင်နစ္စတန် မာနတ်"
          },
          "narrow": "TMT",
          "symbol": "TMT"
        },
        "TND": {
          "displayName": {
            "other": "တူနီးရှား ဒိုင်နာ"
          },
          "narrow": "TND",
          "symbol": "TND"
        },
        "TOP": {
          "displayName": {
            "other": "တွန်ဂါ ဗန်ဂါ"
          },
          "narrow": "T$",
          "symbol": "TOP"
        },
        "TRL": {
          "displayName": {
            "other": "ရှေးဟောင်းတူရကီ လိုင်ရာ"
          },
          "narrow": "TRL",
          "symbol": "TRL"
        },
        "TRY": {
          "displayName": {
            "other": "တူရကီ လိုင်ရာ"
          },
          "narrow": "₺",
          "symbol": "TRY"
        },
        "TTD": {
          "displayName": {
            "other": "ထရီနီဒတ်နှင့် တိုဘက်ဂို ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "TT$"
        },
        "TWD": {
          "displayName": {
            "other": "ထိုင်ဝမ် ဒေါ်လာအသစ်"
          },
          "narrow": "$",
          "symbol": "NT$"
        },
        "TZS": {
          "displayName": {
            "other": "တန်ဇန်းနီးယား သျှီလင်"
          },
          "narrow": "TZS",
          "symbol": "TZS"
        },
        "UAH": {
          "displayName": {
            "other": "ယူကရိန်း ဟီရီဗင်းညား"
          },
          "narrow": "₴",
          "symbol": "UAH"
        },
        "UGX": {
          "displayName": {
            "other": "ယူဂန္ဒာ သျှီလင်"
          },
          "narrow": "UGX",
          "symbol": "UGX"
        },
        "USD": {
          "displayName": {
            "other": "အမေရိကန် ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "US$"
        },
        "USN": {
          "displayName": {
            "other": "အမေရိကန် ဒေါ်လာ (နောက်နေ့)"
          },
          "narrow": "USN",
          "symbol": "USN"
        },
        "USS": {
          "displayName": {
            "other": "အမေရိကန် ဒေါ်လာ (တနေ့တည်း)"
          },
          "narrow": "USS",
          "symbol": "USS"
        },
        "UYU": {
          "displayName": {
            "other": "ဥရုဂွေး ပီဆို"
          },
          "narrow": "$",
          "symbol": "UYU"
        },
        "UZS": {
          "displayName": {
            "other": "ဥဇဘက်ကစ္စတန် ဆော်မ်"
          },
          "narrow": "UZS",
          "symbol": "UZS"
        },
        "VEF": {
          "displayName": {
            "other": "ဗင်နီဇွဲလား ဘိုလီဗာ (၂၀၀၈–၂၀၁၈)"
          },
          "narrow": "Bs",
          "symbol": "VEF"
        },
        "VES": {
          "displayName": {
            "other": "ဗင်နီဇွဲလန်း ဘိုလီဗာ"
          },
          "narrow": "VES",
          "symbol": "VES"
        },
        "VND": {
          "displayName": {
            "other": "ဗီယက်နမ် ဒေါင်"
          },
          "narrow": "₫",
          "symbol": "₫"
        },
        "VUV": {
          "displayName": {
            "other": "ဗနွားတူ ဗားထူ"
          },
          "narrow": "VUV",
          "symbol": "VUV"
        },
        "WST": {
          "displayName": {
            "other": "ဆမိုအား ထားလာ"
          },
          "narrow": "WST",
          "symbol": "WST"
        },
        "XAF": {
          "displayName": {
            "other": "ကင်မရွန်း ဖရန့်"
          },
          "narrow": "FCFA",
          "symbol": "FCFA"
        },
        "XAG": {
          "displayName": {
            "other": "ငွေ"
          },
          "narrow": "XAG",
          "symbol": "XAG"
        },
        "XAU": {
          "displayName": {
            "other": "ရွှေ"
          },
          "narrow": "XAU",
          "symbol": "XAU"
        },
        "XBB": {
          "displayName": {
            "other": "ဥရောပငွေကြေးစံနစ်"
          },
          "narrow": "XBB",
          "symbol": "XBB"
        },
        "XCD": {
          "displayName": {
            "other": "အရှေ့ကာရစ်ဘီယံ ဒေါ်လာ"
          },
          "narrow": "$",
          "symbol": "EC$"
        },
        "XDR": {
          "displayName": {
            "other": "အထူးထုတ်ယူခွင့်"
          },
          "narrow": "XDR",
          "symbol": "XDR"
        },
        "XOF": {
          "displayName": {
            "other": "အနောက် အာဖရိက [CFA] ဖရန့်"
          },
          "narrow": "F CFA",
          "symbol": "F CFA"
        },
        "XPF": {
          "displayName": {
            "other": "[CFP] ဖရန့်"
          },
          "narrow": "CFPF",
          "symbol": "CFPF"
        },
        "XPT": {
          "displayName": {
            "other": "ပလက်တီနမ်"
          },
          "narrow": "XPT",
          "symbol": "XPT"
        },
        "XTS": {
          "displayName": {
            "other": "စမ်းသပ် ငွေကြေး ကုဒ်"
          },
          "narrow": "XTS",
          "symbol": "XTS"
        },
        "XXX": {
          "displayName": {
            "other": "(မသိသို့မဟုတ်မရှိသောငွေကြေး)"
          },
          "narrow": "¤",
          "symbol": "¤"
        },
        "YER": {
          "displayName": {
            "other": "ယီမင်နီ ရီရယ်"
          },
          "narrow": "YER",
          "symbol": "YER"
        },
        "ZAR": {
          "displayName": {
            "other": "တောင်အာဖရိက ရန်း"
          },
          "narrow": "R",
          "symbol": "ZAR"
        },
        "ZMW": {
          "displayName": {
            "other": "ဇင်ဘာဘွေ ခွါးချာ"
          },
          "narrow": "ZK",
          "symbol": "ZMW"
        },
        "ZWD": {
          "displayName": {
            "other": "ဇင်ဘာဘွေ ဒေါ်လာ"
          },
          "narrow": "ZWD",
          "symbol": "ZWD"
        }
      },
      "nu": ["mymr", "latn"],
      "numbers": {
        "currency": {
          "latn": {
            "accounting": "¤ #,##0.00",
            "currencySpacing": {
              "afterInsertBetween": " ",
              "beforeInsertBetween": " "
            },
            "short": {
              "1000": {
                "other": "¤ 0 ထောင်"
              },
              "10000": {
                "other": "¤ 0 သောင်း"
              },
              "100000": {
                "other": "¤ 0 သိန်း"
              },
              "1000000": {
                "other": "¤ 0 သန်း"
              },
              "10000000": {
                "other": "¤ 0 ကုဋေ"
              },
              "100000000": {
                "other": "¤ 00 ကုဋေ"
              },
              "1000000000": {
                "other": "¤ 000 ကုဋေ"
              },
              "10000000000": {
                "other": "¤ 0000 ကုဋေ"
              },
              "100000000000": {
                "other": "¤ ကုဋေ 0 သောင်း"
              },
              "1000000000000": {
                "other": "¤ ကုဋေ 0 သိန်း"
              },
              "10000000000000": {
                "other": "¤ ကုဋေ 0 သန်း"
              },
              "100000000000000": {
                "other": "¤ 0 ကောဋိ"
              }
            },
            "standard": "#,##0.00 ¤",
            "unitPattern": "{1} {0}"
          },
          "mymr": {
            "accounting": "¤ #,##0.00",
            "currencySpacing": {
              "afterInsertBetween": " ",
              "beforeInsertBetween": " "
            },
            "short": {
              "1000": {
                "other": "¤ 0 ထောင်"
              },
              "10000": {
                "other": "¤ 0 သောင်း"
              },
              "100000": {
                "other": "¤ 0 သိန်း"
              },
              "1000000": {
                "other": "¤ 0 သန်း"
              },
              "10000000": {
                "other": "¤ 0 ကုဋေ"
              },
              "100000000": {
                "other": "¤ 00 ကုဋေ"
              },
              "1000000000": {
                "other": "¤ 000 ကုဋေ"
              },
              "10000000000": {
                "other": "¤ 0000 ကုဋေ"
              },
              "100000000000": {
                "other": "¤ ကုဋေ 0 သောင်း"
              },
              "1000000000000": {
                "other": "¤ ကုဋေ 0 သိန်း"
              },
              "10000000000000": {
                "other": "¤ ကုဋေ 0 သန်း"
              },
              "100000000000000": {
                "other": "¤ 0 ကောဋိ"
              }
            },
            "standard": "#,##0.00 ¤",
            "unitPattern": "{1} {0}"
          }
        },
        "decimal": {
          "latn": {
            "long": {
              "1000": {
                "other": "0 ထောင်"
              },
              "10000": {
                "other": "0 သောင်း"
              },
              "100000": {
                "other": "0 သိန်း"
              },
              "1000000": {
                "other": "0 သန်း"
              },
              "10000000": {
                "other": "0 ကုဋေ"
              },
              "100000000": {
                "other": "00 ကုဋေ"
              },
              "1000000000": {
                "other": "000 ကုဋေ"
              },
              "10000000000": {
                "other": "0000 ကုဋေ"
              },
              "100000000000": {
                "other": "ကုဋေ 0 သောင်း"
              },
              "1000000000000": {
                "other": "ကုဋေ 0 သိန်း"
              },
              "10000000000000": {
                "other": "ကုဋေ 0 သန်း"
              },
              "100000000000000": {
                "other": "0 ကောဋိ"
              }
            },
            "short": {
              "1000": {
                "other": "0 ထောင်"
              },
              "10000": {
                "other": "0 သောင်း"
              },
              "100000": {
                "other": "0 သိန်း"
              },
              "1000000": {
                "other": "0 သန်း"
              },
              "10000000": {
                "other": "0 ကုဋေ"
              },
              "100000000": {
                "other": "00 ကုဋေ"
              },
              "1000000000": {
                "other": "000 ကုဋေ"
              },
              "10000000000": {
                "other": "ကုဋေ 0 ထ"
              },
              "100000000000": {
                "other": "ကုဋေ 0 သ"
              },
              "1000000000000": {
                "other": "ဋေ 0 သိန်း"
              },
              "10000000000000": {
                "other": "ဋေ 0 သန်း"
              },
              "100000000000000": {
                "other": "0 ကောဋိ"
              }
            },
            "standard": "#,##0.###"
          },
          "mymr": {
            "long": {
              "1000": {
                "other": "0 ထောင်"
              },
              "10000": {
                "other": "0 သောင်း"
              },
              "100000": {
                "other": "0 သိန်း"
              },
              "1000000": {
                "other": "0 သန်း"
              },
              "10000000": {
                "other": "0 ကုဋေ"
              },
              "100000000": {
                "other": "00 ကုဋေ"
              },
              "1000000000": {
                "other": "000 ကုဋေ"
              },
              "10000000000": {
                "other": "0000 ကုဋေ"
              },
              "100000000000": {
                "other": "ကုဋေ 0 သောင်း"
              },
              "1000000000000": {
                "other": "ကုဋေ 0 သိန်း"
              },
              "10000000000000": {
                "other": "ကုဋေ 0 သန်း"
              },
              "100000000000000": {
                "other": "0 ကောဋိ"
              }
            },
            "short": {
              "1000": {
                "other": "0 ထောင်"
              },
              "10000": {
                "other": "0 သောင်း"
              },
              "100000": {
                "other": "0 သိန်း"
              },
              "1000000": {
                "other": "0 သန်း"
              },
              "10000000": {
                "other": "0 ကုဋေ"
              },
              "100000000": {
                "other": "00 ကုဋေ"
              },
              "1000000000": {
                "other": "000 ကုဋေ"
              },
              "10000000000": {
                "other": "ကုဋေ 0 ထ"
              },
              "100000000000": {
                "other": "ကုဋေ 0 သ"
              },
              "1000000000000": {
                "other": "ဋေ 0 သိန်း"
              },
              "10000000000000": {
                "other": "ဋေ 0 သန်း"
              },
              "100000000000000": {
                "other": "0 ကောဋိ"
              }
            },
            "standard": "#,##0.###"
          }
        },
        "nu": ["mymr", "latn"],
        "percent": {
          "latn": "#,##0%",
          "mymr": "#,##0%"
        },
        "symbols": {
          "latn": {
            "approximatelySign": "~",
            "decimal": ".",
            "exponential": "E",
            "group": ",",
            "infinity": "∞",
            "list": ";",
            "minusSign": "-",
            "nan": "ဂဏန်းမဟုတ်သော",
            "perMille": "‰",
            "percentSign": "%",
            "plusSign": "+",
            "rangeSign": " ",
            "superscriptingExponent": "×",
            "timeSeparator": ":"
          },
          "mymr": {
            "approximatelySign": "~",
            "decimal": ".",
            "exponential": "E",
            "group": ",",
            "infinity": "∞",
            "list": "၊",
            "minusSign": "-",
            "nan": "ဂဏန်းမဟုတ်သော",
            "perMille": "‰",
            "percentSign": "%",
            "plusSign": "+",
            "rangeSign": " ",
            "superscriptingExponent": "×",
            "timeSeparator": ":"
          }
        }
      },
      "units": {
        "compound": {
          "per": {
            "long": "တစ်{1} လျှင် {0}",
            "narrow": "{0}/{1}",
            "short": "{0}/{1}"
          }
        },
        "simple": {
          "acre": {
            "long": {
              "other": "{0} ဧက"
            },
            "narrow": {
              "other": "{0} ac"
            },
            "perUnit": {},
            "short": {
              "other": "{0} ac"
            }
          },
          "bit": {
            "long": {
              "other": "{0} ဘစ်"
            },
            "narrow": {
              "other": "{0} bit"
            },
            "perUnit": {},
            "short": {
              "other": "{0} bit"
            }
          },
          "byte": {
            "long": {
              "other": "{0} ဘိုက်"
            },
            "narrow": {
              "other": "{0}B"
            },
            "perUnit": {},
            "short": {
              "other": "{0} byte"
            }
          },
          "celsius": {
            "long": {
              "other": "{0} ဒီဂရီ စင်တီဂရိတ်"
            },
            "narrow": {
              "other": "{0}°C"
            },
            "perUnit": {},
            "short": {
              "other": "{0}°C"
            }
          },
          "centimeter": {
            "long": {
              "other": "{0} စင်တီမီတာ"
            },
            "narrow": {
              "other": "{0} cm"
            },
            "perUnit": {
              "long": "တစ်စင်တီမီလာလျှင် {0}",
              "narrow": "{0}/cm",
              "short": "{0}/cm"
            },
            "short": {
              "other": "{0} cm"
            }
          },
          "day": {
            "long": {
              "other": "{0} ရက်"
            },
            "narrow": {
              "other": "{0} ရက်"
            },
            "perUnit": {
              "long": "တစ်ရက်လျှင် {0}",
              "narrow": "{0}/ ရက်",
              "short": "{0}/ ရက်"
            },
            "short": {
              "other": "{0} ရက်"
            }
          },
          "degree": {
            "long": {
              "other": "{0} ဒီဂရီ"
            },
            "narrow": {
              "other": "{0}°"
            },
            "perUnit": {},
            "short": {
              "other": "{0} deg"
            }
          },
          "fahrenheit": {
            "long": {
              "other": "{0} ဒီဂရီ ဖာရင်ဟိုက်"
            },
            "narrow": {
              "other": "{0}°F"
            },
            "perUnit": {},
            "short": {
              "other": "{0}°F"
            }
          },
          "fluid-ounce": {
            "long": {
              "other": "{0} အရည်အောင်စ"
            },
            "narrow": {
              "other": "{0} fl oz"
            },
            "perUnit": {},
            "short": {
              "other": "{0} fl oz"
            }
          },
          "foot": {
            "long": {
              "other": "{0} ပေ"
            },
            "narrow": {
              "other": "{0}′"
            },
            "perUnit": {
              "long": "တစ်ပေလျှင် {0}",
              "narrow": "{0}/ft",
              "short": "{0}/ft"
            },
            "short": {
              "other": "{0} ft"
            }
          },
          "gallon": {
            "long": {
              "other": "{0} ဂါလံ"
            },
            "narrow": {
              "other": "{0} ဂါလံ"
            },
            "perUnit": {
              "long": "တစ်ဂါလံလျှင် {0}",
              "narrow": "{0}/gal US",
              "short": "{0}/gal US"
            },
            "short": {
              "other": "{0} ဂါလံ"
            }
          },
          "gigabit": {
            "long": {
              "other": "{0} ဂစ်ဂါဘစ်"
            },
            "narrow": {
              "other": "{0} Gb"
            },
            "perUnit": {},
            "short": {
              "other": "{0} Gb"
            }
          },
          "gigabyte": {
            "long": {
              "other": "{0} ဂစ်ဂါဘိုက်"
            },
            "narrow": {
              "other": "{0} GB"
            },
            "perUnit": {},
            "short": {
              "other": "{0} GB"
            }
          },
          "gram": {
            "long": {
              "other": "{0} ဂရမ်"
            },
            "narrow": {
              "other": "{0} g"
            },
            "perUnit": {
              "long": "တစ်ဂရမ်လျှင် {0}",
              "narrow": "{0}/g",
              "short": "{0}/g"
            },
            "short": {
              "other": "{0} g"
            }
          },
          "hectare": {
            "long": {
              "other": "{0} ဟက်တာ"
            },
            "narrow": {
              "other": "{0} ha"
            },
            "perUnit": {},
            "short": {
              "other": "{0} ha"
            }
          },
          "hour": {
            "long": {
              "other": "{0} နာရီ"
            },
            "narrow": {
              "other": "{0} နာရီ"
            },
            "perUnit": {
              "long": "တစ်နာရီလျှင် {0}",
              "narrow": "{0}/ နာရီ",
              "short": "{0}/ နာရီ"
            },
            "short": {
              "other": "{0} နာရီ"
            }
          },
          "inch": {
            "long": {
              "other": "{0} လက်မ"
            },
            "narrow": {
              "other": "{0}″"
            },
            "perUnit": {
              "long": "တစ်လက်မလျှင် {0}",
              "narrow": "{0}/in",
              "short": "{0}/in"
            },
            "short": {
              "other": "{0} လက်မ"
            }
          },
          "kilobit": {
            "long": {
              "other": "{0} ကီလိုဘစ်"
            },
            "narrow": {
              "other": "{0} kb"
            },
            "perUnit": {},
            "short": {
              "other": "{0} kb"
            }
          },
          "kilobyte": {
            "long": {
              "other": "{0} ကီလိုဘိုက်"
            },
            "narrow": {
              "other": "{0} kB"
            },
            "perUnit": {},
            "short": {
              "other": "{0} kB"
            }
          },
          "kilogram": {
            "long": {
              "other": "{0} ကီလိုဂရမ်"
            },
            "narrow": {
              "other": "{0} kg"
            },
            "perUnit": {
              "long": "တစ်ကီလိုဂရမ်လျှင် {0}",
              "narrow": "{0}/kg",
              "short": "{0}/kg"
            },
            "short": {
              "other": "{0} kg"
            }
          },
          "kilometer": {
            "long": {
              "other": "{0} ကီလိုမီတာ"
            },
            "narrow": {
              "other": "{0}km"
            },
            "perUnit": {
              "long": "တစ်ကီလိုမီတာလျှင် {0}",
              "narrow": "{0}/km",
              "short": "{0}/km"
            },
            "short": {
              "other": "{0} km"
            }
          },
          "kilometer-per-hour": {
            "long": {
              "other": "တစ်နာရီလျှင် {0} ကီလိုမီတာ"
            },
            "narrow": {
              "other": "{0} km/h"
            },
            "perUnit": {},
            "short": {
              "other": "{0} km/h"
            }
          },
          "liter": {
            "long": {
              "other": "{0} လီတာ"
            },
            "narrow": {
              "other": "{0}L"
            },
            "perUnit": {
              "long": "တစ်လီတာလျှင် {0}",
              "narrow": "{0}/လီတာ",
              "short": "{0}/l"
            },
            "short": {
              "other": "{0} လီတာ"
            }
          },
          "liter-per-kilometer": {
            "long": {
              "other": "တစ်ကီလိုမီတာရှိ {0} လီတာ"
            },
            "narrow": {
              "other": "{0} L/km"
            },
            "perUnit": {},
            "short": {
              "other": "{0} L/km"
            }
          },
          "megabit": {
            "long": {
              "other": "{0} မီဂါဘစ်"
            },
            "narrow": {
              "other": "{0} Mb"
            },
            "perUnit": {},
            "short": {
              "other": "{0} Mb"
            }
          },
          "megabyte": {
            "long": {
              "other": "{0} မီဂါဘိုက်"
            },
            "narrow": {
              "other": "{0} MB"
            },
            "perUnit": {},
            "short": {
              "other": "{0} MB"
            }
          },
          "meter": {
            "long": {
              "other": "{0} မီတာ"
            },
            "narrow": {
              "other": "{0} m"
            },
            "perUnit": {
              "long": "တစ်မီတာလျှင် {0}",
              "narrow": "{0}/m",
              "short": "{0}/m"
            },
            "short": {
              "other": "{0} m"
            }
          },
          "meter-per-second": {
            "long": {
              "other": "တစ်စက္ကန့်လျှင် {0} မီတာ"
            },
            "narrow": {
              "other": "{0} m/s"
            },
            "perUnit": {},
            "short": {
              "other": "{0} m/s"
            }
          },
          "mile": {
            "long": {
              "other": "{0} မိုင်"
            },
            "narrow": {
              "other": "{0} mi"
            },
            "perUnit": {},
            "short": {
              "other": "{0} mi"
            }
          },
          "mile-per-gallon": {
            "long": {
              "other": "တစ်ဂါလံလျှင် {0} မိုင်"
            },
            "narrow": {
              "other": "{0} mpg"
            },
            "perUnit": {},
            "short": {
              "other": "{0} mpg"
            }
          },
          "mile-per-hour": {
            "long": {
              "other": "တစ်နာရီလျှင် {0} မိုင်"
            },
            "narrow": {
              "other": "{0} mi/h"
            },
            "perUnit": {},
            "short": {
              "other": "{0} mi/h"
            }
          },
          "mile-scandinavian": {
            "long": {
              "other": "{0} စကင်ဒီနေဗီးယန်း မိုင်"
            },
            "narrow": {
              "other": "{0} smi"
            },
            "perUnit": {},
            "short": {
              "other": "{0} smi"
            }
          },
          "milliliter": {
            "long": {
              "other": "{0} မီလီလီတာ"
            },
            "narrow": {
              "other": "{0} mL"
            },
            "perUnit": {},
            "short": {
              "other": "{0} mL"
            }
          },
          "millimeter": {
            "long": {
              "other": "{0} မီလီမီတာ"
            },
            "narrow": {
              "other": "{0} mm"
            },
            "perUnit": {},
            "short": {
              "other": "{0} mm"
            }
          },
          "millisecond": {
            "long": {
              "other": "{0} မီလီစက္ကန့်"
            },
            "narrow": {
              "other": "{0} ms"
            },
            "perUnit": {},
            "short": {
              "other": "{0} မီလီစက္ကန့်"
            }
          },
          "minute": {
            "long": {
              "other": "{0} မိနစ်"
            },
            "narrow": {
              "other": "{0} မိနစ်"
            },
            "perUnit": {
              "long": "တစ်မိနစ်လျှင် {0}",
              "narrow": "{0}/ မိနစ်",
              "short": "{0}/ မိနစ်"
            },
            "short": {
              "other": "{0} မိနစ်"
            }
          },
          "month": {
            "long": {
              "other": "{0} လ"
            },
            "narrow": {
              "other": "{0} လ"
            },
            "perUnit": {
              "long": "တစ်လလျှင် {0}",
              "narrow": "{0}/ လ",
              "short": "{0}/ လ"
            },
            "short": {
              "other": "{0} လ"
            }
          },
          "ounce": {
            "long": {
              "other": "{0} အောင်စ"
            },
            "narrow": {
              "other": "{0} oz"
            },
            "perUnit": {
              "long": "တစ်အောင်စလျှင် {0}",
              "narrow": "{0}/oz",
              "short": "{0}/oz"
            },
            "short": {
              "other": "{0} oz"
            }
          },
          "percent": {
            "long": {
              "other": "{0} ရာခိုင်နှုန်း"
            },
            "narrow": {
              "other": "{0}%"
            },
            "perUnit": {},
            "short": {
              "other": "{0}%"
            }
          },
          "petabyte": {
            "long": {
              "other": "{0} ပက်တာဘိုက်"
            },
            "narrow": {
              "other": "{0} PB"
            },
            "perUnit": {},
            "short": {
              "other": "{0} PB"
            }
          },
          "pound": {
            "long": {
              "other": "{0} ပေါင်"
            },
            "narrow": {
              "other": "{0} lb"
            },
            "perUnit": {
              "long": "တစ်ပေါင်လျှင် {0}",
              "narrow": "{0}/lb",
              "short": "{0}/lb"
            },
            "short": {
              "other": "{0} lb"
            }
          },
          "second": {
            "long": {
              "other": "{0} စက္ကန့်"
            },
            "narrow": {
              "other": "{0} s"
            },
            "perUnit": {
              "long": "တစ်စက္ကန့်လျှင် {0}",
              "narrow": "{0}/s",
              "short": "{0}/s"
            },
            "short": {
              "other": "{0} sec"
            }
          },
          "stone": {
            "long": {
              "other": "{0} စတုန်"
            },
            "narrow": {
              "other": "{0} စတုန်"
            },
            "perUnit": {},
            "short": {
              "other": "{0} စတုန်"
            }
          },
          "terabit": {
            "long": {
              "other": "{0} တယ်ရာဘစ်"
            },
            "narrow": {
              "other": "{0} Tb"
            },
            "perUnit": {},
            "short": {
              "other": "{0} Tb"
            }
          },
          "terabyte": {
            "long": {
              "other": "{0} တယ်ရာဘိုက်"
            },
            "narrow": {
              "other": "{0} TB"
            },
            "perUnit": {},
            "short": {
              "other": "{0} TB"
            }
          },
          "week": {
            "long": {
              "other": "{0} ပတ်"
            },
            "narrow": {
              "other": "{0} ပတ်"
            },
            "perUnit": {
              "long": "တစ်ပတ်လျှင် {0}",
              "narrow": "{0}/ ပတ်",
              "short": "{0}/ ပတ်"
            },
            "short": {
              "other": "{0} ပတ်"
            }
          },
          "yard": {
            "long": {
              "other": "{0} ကိုက်"
            },
            "narrow": {
              "other": "{0} yd"
            },
            "perUnit": {},
            "short": {
              "other": "{0} ကိုက်"
            }
          },
          "year": {
            "long": {
              "other": "{0} နှစ်"
            },
            "narrow": {
              "other": "{0} နှစ်"
            },
            "perUnit": {
              "long": "တစ်နှစ်လျှင် {0}",
              "narrow": "{0}/ နှစ်",
              "short": "{0}/ နှစ်"
            },
            "short": {
              "other": "{0} နှစ်"
            }
          }
        }
      }
    },
    "locale": "my"
  });
}